/** @jsx jsx */
import { jsx } from '../jsx';

export const GridCell = props => <div {...props} />;

GridCell.defaultProps = {
  width: 1,
};
